    
<template>
    <div class="dashBox" style="padding-bottom:100px;">
        <a-spin :spinning="tloading">
            <a-empty v-if="pie_data.length == 0" description="暂无数据" style="margin-top:80px;" />
            <div :id="boxid" style="width: 100%;"></div>
        </a-spin>
    </div>
</template>

<script>

export default {
    props:{
        boxid:String
    },
    data() {
        return {
            chartSys:null,
            chartDate:[1],
            searchP:{
                channelcode:'',
                passwaytype:'',
            },
            pie_data:[],
            tloading:false,
        }
    },

    methods: {
        resetData(){
            this.sendct_ = [];
            this.readct_ = [];
            this.time_ = [];
        },
        loadData(searchP){
            if(searchP){
                this.searchP = searchP
            }
            let that = this;
            that.pie_data = [];
            that.tloading = true;
            that.resetData();
            let params = {
                channelcode:that.searchP.channelcode,
                messagestypecode:that.searchP.messagestypecode,
                querytype:that.searchP.selectedTimeRange.split('~')[2],
                starttime:that.searchP.selectedTimeRange.split('~')[0],
                endtime:that.searchP.selectedTimeRange.split('~')[1],
            };
            that.$store.dispatch({
                type: this.boxid == 'pie_id_type' ? 'mcmsmanager/queryMessageSendByType' : 'mcmsmanager/queryMessageSendByStatus',
                params:params
            }).then((res)=>{
                that.tloading = false
                if(res.status == 200 && res.data.success == '1'){
                    let res_data = res.data.data;
                    if(this.boxid == 'pie_id_type'){
                        res_data.items.forEach(element => {
                            that.pie_data.push(
                                {
                                    name:element.messagestypename,
                                    value:element.sendct
                                }
                            );
                        });
                    }
                    else{
                        that.pie_data.push(
                            {
                                name:'未处理',
                                value:res_data.untreatedct
                            }
                        );
                        that.pie_data.push(
                            {
                                name:'失败',
                                value:res_data.failct
                            }
                        );
                        that.pie_data.push(
                            {
                                name:'成功',
                                value:res_data.successct
                            }
                        );
                    }
                    
                    that.analystData();
                }
            }).catch(() => {
                that.tloading = false
            });
        },
        //按日期统计数据
        analystData(){
            let that = this;
            if(that.chartSys){
                that.chartSys.clear();
            }
            document.getElementById(this.boxid).style.height = "400px";
            that.chartSys = that.$echarts.init(document.getElementById(this.boxid));
            
            let option = that.getDatailOption();
            // 窗口大小自适应方案
            that.chartSys.setOption(option);
            that.chartSys.off('click');
            that.chartSys.on('click', function () {
                // console.log(params);
                // let query = {
                //     selectedTimeRange:that.searchP.selectedTimeRange,
                // }
                // if(that.boxid == 'pie_id_type'){
                //     //按类型
                //     query.messagestypename = params.name
                // }
                // else{
                //     //按状态
                //     query.messagestypecode = that.searchP.messagestypecode
                //     query.status = params.name
                // }
                // that.$router.push({
                //     path: "/mcmsmanager/message/wshistory",
                //     query:query
                // });
            });
            
        },
        getDatailOption(){
            let that = this;
           
            // 基于准备好的dom，初始化echarts实例
            // 绘制图表配置
            let option = {
                title: {
                    text:  that.boxid=='pie_id_type' ? '消息类型' : '消息状态',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    right: '5px',
                    top:'bottom'
                },
                color:that.G.getChartColors(),
                series: [
                    {
                        type: 'pie',
                        radius: '50%',
                        data: this.pie_data,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };
            return option
        },
        chartResize(){
            let eleArr = [this.chartSys];
            for(let i = 0; i<eleArr.length; i++){
                //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
                setTimeout(function(){
                    if(eleArr[i]){
                        eleArr[i].resize();
                    }
                }, 200);
            }
        },
    },
    mounted() {
        window.addEventListener("resize", this.chartResize);
    },
    destroyed(){
        window.removeEventListener("resize", this.chartResize);

    },

}
</script>

